import React, { useMemo } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import { RootState } from "@/store/store";
import { ROUTES } from "@/enums/routes";

interface ProtectedRouteProps {
  condition?: (args: {
    profile: RootState["auth"]["profile"];
    role: RootState["userDetail"]["role"];
  }) => boolean;
  redirectTo?: string;
}

const ProtectedRoute = ({
  condition,
  redirectTo = ROUTES.LOGIN,
}: ProtectedRouteProps) => {
  const role = useSelector((state: RootState) => state.userDetail.role);
  const profile = useSelector((state: RootState) => state.auth.profile);
  const location = useLocation();

  const token = useMemo(() => profile?.accessToken, [profile]);

  if (profile === undefined) {
    return <div>Loading...</div>;
  }

  const isAllowed = token && (!condition || condition({ profile, role }));

  return isAllowed ? (
    <Outlet />
  ) : (
    <Navigate to={redirectTo} state={{ from: location }} replace />
  );
};

export default ProtectedRoute;
